import { render } from "./RaceCountdown.vue?vue&type=template&id=b5125e5c&scoped=true"
import script from "./RaceCountdown.vue?vue&type=script&lang=js"
export * from "./RaceCountdown.vue?vue&type=script&lang=js"

import "./RaceCountdown.vue?vue&type=style&index=0&id=b5125e5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5125e5c"]])

export default __exports__